module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/3-1b9eba01fef62a71957963874d713154.jpg";